import { useMemo } from 'react';

import { ThemeConfig } from 'antd';
import { useSelector } from 'react-redux';

import { CustomConfig } from '../models/CustomConfig';
import { DashboardConfig } from '../models/DashboardConfig';
import {
  DEFAULT_DASHBOARD_MENU_ITEM_ACTIVE_BG,
  DEFAULT_DASHBOARD_MENU_ITEM_SELECTED_BG,
  DEFAULT_DASHBOARD_MENU_ITEM_SELECTED_COLOR,
  DEFAULT_PRIMARY_COLOR,
  DEFAULT_SECONDARY_COLOR,
} from './Constants';

export const useThemeLayoutConfig = (): {
  theme: ThemeConfig;
  customValues: CustomConfig;
} => {
  const dashboardConfig: DashboardConfig =
    useSelector((state: any) => state.dashboardConfig) || {};

  const {
    primaryColor = DEFAULT_PRIMARY_COLOR,
    menuItemSelectedBg = DEFAULT_DASHBOARD_MENU_ITEM_SELECTED_BG,
    menuItemActiveBg = DEFAULT_DASHBOARD_MENU_ITEM_ACTIVE_BG,
    menuItemSelectedColor = DEFAULT_DASHBOARD_MENU_ITEM_SELECTED_COLOR,
    secondaryColor = DEFAULT_SECONDARY_COLOR,
  } = dashboardConfig;

  // El objeto theme se pasa a ConfigProvider; antd usa DesignTokenContext y
  // cualquier referencia nueva invalida el context → recálculo de tokens y
  // re-render en cascada de todos los componentes antd (Menu, Drawer, etc.).
  const theme = useMemo<ThemeConfig>(
    () => ({
      token: {
        colorPrimary: primaryColor,
      },
      components: {
        Menu: {
          itemSelectedBg: menuItemSelectedBg,
          itemActiveBg: menuItemActiveBg,
          itemSelectedColor: menuItemSelectedColor,
        },
        Layout: {
          triggerBg: primaryColor,
        },
      },
    }),
    [primaryColor, menuItemSelectedBg, menuItemActiveBg, menuItemSelectedColor]
  );

  const customValues = useMemo<CustomConfig>(
    () => ({ secondaryColor }),
    [secondaryColor]
  );

  return useMemo(() => ({ theme, customValues }), [theme, customValues]);
};
